export const UseType = {
  USE: 'USE',
  UNUSED: 'UNUSED'
} as const

export type UseType = keyof typeof UseType;